import * as React from "react";
import TablePagination from "@mui/material/TablePagination";
import {
  useGridApiContext,
  useGridSelector,
  gridPageSelector,
  gridRowCountSelector,
  gridPageSizeSelector,
} from "@mui/x-data-grid";
import CustomPaginationActions from "../CustomPaginationActions";

export const rowPerPageOptions = [10, 15, 20, 25];

function CustomPagination() {
  const apiRef = useGridApiContext();
  const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridRowCountSelector);

  const handleChangePage = (_event, newPage) => {
    apiRef.current.setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    apiRef.current.setPageSize(event.target.value);
    apiRef.current.setPage(0);
  };

  return (
    <TablePagination
      component="div"
      count={pageCount}
      page={page}
      onPageChange={handleChangePage}
      rowsPerPage={pageSize}
      rowsPerPageOptions={rowPerPageOptions}
      onRowsPerPageChange={handleChangeRowsPerPage}
      showFirstButton
      showLastButton
      ActionsComponent={CustomPaginationActions}
    />
  );
}

export default CustomPagination;
